import { StyledSpanishFlag } from './LanguageFlag.styled';

export default function SpanishFlag() {
  return <StyledSpanishFlag />;
}
